export default "__VITE_ASSET__DMvzlvxV__"